import React from 'react'
import { VStack, Text } from 'rsuite'

import * as passwordValidators from '../../../shared/passwordValidators'

type Props = {
  password: string
  confirmPassword: string
  requireConfirmation?: boolean
}

const PasswordRequirements: React.FC<Props> = (props): React.ReactElement => {
  const { password, confirmPassword, requireConfirmation = true } = props

  if (
    password.length === 0 &&
    (!requireConfirmation || confirmPassword.length === 0)
  ) {
    return <></>
  }

  const passwordSubValidatorChecks = passwordValidators.subvalidators(password)

  const passwordValidStyle = (test: boolean) => (test ? 'green' : 'red')

  const hasEightCharacters = passwordValidStyle(
    passwordSubValidatorChecks.hasEightCharacters,
  )
  const hasDigit = passwordValidStyle(passwordSubValidatorChecks.hasDigit)
  const hasLowerCase = passwordValidStyle(
    passwordSubValidatorChecks.hasLowerCase,
  )
  const hasSpecialCharacter = passwordValidStyle(
    passwordSubValidatorChecks.hasSpecialCharacter,
  )
  const passwordsMatch = passwordValidStyle(password === confirmPassword)

  return (
    <VStack spacing={2}>
      <Text color={hasEightCharacters}>At least 8 Characters</Text>
      <Text color={hasDigit}>At least 1 digit</Text>
      <Text color={hasLowerCase}>At least one letter</Text>
      <Text color={hasSpecialCharacter}>At least one special character</Text>
      {requireConfirmation && (
        <Text color={passwordsMatch}>Passwords Match</Text>
      )}
    </VStack>
  )
}

export default PasswordRequirements
